export default "/_next/static/images/a8135d3cd7209591443aab7171e9d388.jpg";